import {
  ADD_SURCHARGE,
  ADD_SURCHARGE_SUCCESS,
  ADD_SURCHARGE_FAILURE,
  EDIT_SURCHARGE,
  EDIT_SURCHARGE_SUCCESS,
  EDIT_SURCHARGE_FAILURE,
  DELETE_SURCHARGE,
  DELETE_SURCHARGE_SUCCESS,
  DELETE_SURCHARGE_FAILURE,
  RESTORE_SURCHARGE,
  RESTORE_SURCHARGE_SUCCESS,
  RESTORE_SURCHARGE_FAILURE
} from "@utils/actionTypes";

const INIT_STATE = {
  addingSurcharge: false,
  editingSurcharge: false,
  deletingSurcharge: false,
  restoringSurcharge: false,
};

const surchargeReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_SURCHARGE:
      return { ...state, addingSurcharge: true };
    case ADD_SURCHARGE_SUCCESS:
      return { ...state, addingSurcharge: false };
    case ADD_SURCHARGE_FAILURE:
      return { ...state, addingSurcharge: false };

    case EDIT_SURCHARGE:
      return { ...state, editingSurcharge: true };
    case EDIT_SURCHARGE_SUCCESS:
      return { ...state, editingSurcharge: false };
    case EDIT_SURCHARGE_FAILURE:
      return { ...state, editingSurcharge: false };

    case DELETE_SURCHARGE:
      return { ...state, deletingSurcharge: true };
    case DELETE_SURCHARGE_SUCCESS:
      return { ...state, deletingSurcharge: false };
    case DELETE_SURCHARGE_FAILURE:
      return { ...state, deletingSurcharge: false };

    case RESTORE_SURCHARGE:
      return { ...state, restoringSurcharge: true };
    case RESTORE_SURCHARGE_SUCCESS:
      return { ...state, restoringSurcharge: false };
    case RESTORE_SURCHARGE_FAILURE:
      return { ...state, restoringSurcharge: false };

    default:
      return state;
  }
};
export default surchargeReducer;
